module.exports = __webpack_public_path__ + "static/direct-debit-5bd75bb3e5503ae5273268cf014d414e.jpg";